<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="city"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="Cidade"
        label-for="city"
      >
        <v-select
          id="city"
          v-model="dataSelected"
          :class="errors.length > 0 ? 'error-select' : ''"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :filter="fuseSearch"
          label="code"
          :options="dataOptions"
          :placeholder="'Cidade'"
          :disabled="readonly"
          :clearable="!readonly"
        >
          <template #option="{ name }">
            <span>{{ name }} </span>
          </template>

          <template #selected-option="{ name }">
            <span>{{ name }} </span>
          </template>

          <template #no-options>
            Não há opções de cidades.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BFormGroup,
} from 'bootstrap-vue'
import {
  ValidationProvider,
} from 'vee-validate'
import { required } from '@validations'
import { useToast } from 'vue-toastification/composition'
import Fuse from 'fuse.js'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  model: {
    prop: 'value',
    event: 'dataChange',
  },
  props: {
    value: {
      type: [Object, String],
      required: false,
      default: null,
    },
    state: {
      type: [String, Number],
      required: false,
      default: '',
    },
    readonly: {
      type: Boolean,
      required: true,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    const dataOptions = []
    const dataSelected = ''

    return {
      dataOptions,
      dataSelected,
      required,
    }
  },
  watch: {
    value: function updateProp(val) {
      this.dataSelected = val
    },
    dataSelected: function updateData(val) {
      if (val === null) {
        this.$emit('dataChange', '')
      } else {
        this.$emit('dataChange', val)
        this.$emit('code', val.code)
        this.$emit('name', val.name)
      }
    },
    state: function updateState(val) {
      if (val !== '') {
        this.onCreate()
      }
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      let param = {}

      if (this.state !== '') {
        param = { state: this.state }
      } else {
        this.dataOptions = []
        this.$emit('ready', true)
        return
      }

      syslic
        .address
        .fetchCities(param)
        .then(response => {
          this.dataOptions = response.results

          if (!this.isOptionAvaiable(this.dataSelected.id)) {
            this.dataSelected = ''
          }
          this.$emit('ready', true)
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao ler os dados.',
              text: 'Não foi possível ler os dados do servidor, por favor entre em contato com o administrador do sistema.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['code', 'name'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
    isOptionAvaiable(id) {
      let avaiable = false
      this.dataOptions.forEach(data => {
        if (data.id === id) {
          avaiable = true
        }
      })
      return avaiable
    },
  },
  setup() {
    const toast = useToast()

    return {
      toast,
    }
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
